import { HTTPStatusCodes } from 'constants/httpStatusCodes';
import { INTERVIEW_CALL_TITLE_BY_TYPE } from 'features/sendouts/constants/constants';
import strings from 'strings';
import { interviewDetailsSubmitHandlers } from 'UI/components/organisms/InterviewDetailsDrawer/utils';
import { getErrorMessage } from 'UI/utils';

const SUBMIT_MESSAGES = strings.sendoutsV2.alerts.submitMessages;

const buildSubmitInterviewCallAlert = ({ action, body, callType, severity }) => ({
  severity,
  title: strings.formatString(SUBMIT_MESSAGES[severity].title, {
    processType: INTERVIEW_CALL_TITLE_BY_TYPE[callType],
    action
  }),
  autoHideDuration: 5000,
  ...(body ? { body } : {})
});

export const submitInterviewCall = async ({ callType, interviewId, itemId, payload }) => {
  const successAction = itemId ? SUBMIT_MESSAGES.actions.updated : SUBMIT_MESSAGES.actions.created;
  const errorAction = itemId ? SUBMIT_MESSAGES.actions.updating : SUBMIT_MESSAGES.actions.creating;

  const submitHandler = interviewDetailsSubmitHandlers[callType];
  if (!submitHandler) {
    throw new Error(`Missing submit handler for interview call type: ${callType}`);
  }

  try {
    const response = await submitHandler(payload, interviewId, itemId);
    const isSuccessfulResponse =
      response.status === HTTPStatusCodes.Ok || response.status === HTTPStatusCodes.Created;

    if (!isSuccessfulResponse) {
      return {
        success: false,
        response,
        alert: buildSubmitInterviewCallAlert({
          action: errorAction,
          body: strings.formatString(SUBMIT_MESSAGES.unexpectedStatus, { status: response.status }),
          callType,
          severity: 'error'
        })
      };
    }

    return {
      success: true,
      response,
      alert: buildSubmitInterviewCallAlert({
        action: successAction,
        callType,
        severity: 'success'
      })
    };
  } catch (error) {
    return {
      success: false,
      error,
      alert: buildSubmitInterviewCallAlert({
        action: errorAction,
        body: getErrorMessage(error, error?.message ?? strings.shared.ui.unknownError.title),
        callType,
        severity: 'error'
      })
    };
  }
};
